import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



// Components
import PaymentConditionPill from "./PaymentConditionPill.vue"

interface Props {
	content: { [key: string]: string }
	height?: number
	width?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FlexiblePaymentConditionPill',
  props: {
    content: {},
    height: {},
    width: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PaymentConditionPill, {
    height: props.height,
    width: props.width
  }, {
    icon: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        width: "11",
        height: "10",
        class: "icon"
      }, [
        _createElementVNode("use", { "xlink:href": "#___icon___flex-payment" })
      ], -1)
    ])),
    content: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(props.content.flex_product), 1)
    ]),
    _: 1
  }, 8, ["height", "width"]))
}
}

})